(function () {
  'use strict';

  function activateMedia(section, mediaId) {
    if (!mediaId) return;

    var target = section.querySelector('[data-product-media][data-media-id="' + mediaId + '"]');
    if (!target) return;

    section.querySelectorAll('[data-product-media]').forEach(function (media) {
      media.hidden = media !== target;
    });

    section.querySelectorAll('[data-media-thumbnail]').forEach(function (thumbnail) {
      var isActive = thumbnail.dataset.mediaId === String(mediaId);
      thumbnail.classList.toggle('is-active', isActive);
      thumbnail.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  function updateVariant(section, select) {
    var option = select.options[select.selectedIndex];
    if (!option) return;

    var price = section.querySelector('[data-product-price] span');
    var submit = section.querySelector('[data-product-submit]');
    var submitText = section.querySelector('[data-product-submit-text]');
    var available = option.dataset.available === 'true';

    if (price && option.dataset.price) {
      price.textContent = option.dataset.price;
    }

    if (option.dataset.mediaId) {
      activateMedia(section, option.dataset.mediaId);
    }

    if (submit) {
      submit.disabled = !available;
      submit.setAttribute('aria-disabled', available ? 'false' : 'true');
    }

    if (submitText) {
      submitText.textContent = available
        ? section.dataset.addToCartText || 'Add to cart'
        : section.dataset.soldOutText || 'Sold out';
    }

    if (window.history && window.history.replaceState && section.dataset.productUrl) {
      var nextUrl = section.dataset.productUrl + '?variant=' + encodeURIComponent(option.value);
      window.history.replaceState({ path: nextUrl }, '', nextUrl);
    }
  }

  function initProductSection(section) {
    if (!section || section.dataset.variantMediaReady === 'true') return;
    section.dataset.variantMediaReady = 'true';

    var select = section.querySelector('[data-variant-select]');
    if (select) {
      select.addEventListener('change', function () {
        updateVariant(section, select);
      });
    }

    section.querySelectorAll('[data-media-thumbnail]').forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function () {
        activateMedia(section, thumbnail.dataset.mediaId);
      });
    });
  }

  function init(root) {
    if (root.matches && root.matches('[data-product-section]')) {
      initProductSection(root);
    }

    root.querySelectorAll('[data-product-section]').forEach(initProductSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
